export interface FitterInfo {
  message: string;
  isReadyToBill?: boolean;
}
